import React from 'react';
import UsersInformation from '../Classes/UsersInformation';
import ClassesInformation from './ClassesInformation';
import BasicInformation from './BasicInformation';
import SectionCollapse from '../../../../../section/SectionCollapse';

const AssessmentInfo = ({ detail = {} }) => {
  return (
    <>
      <div className='py-2' />
      <SectionCollapse title='Basic Information'>
        <BasicInformation detail={detail} />
      </SectionCollapse>
      <ClassesInformation type='Classes' items={detail?.classes} />
      <UsersInformation type='Students' items={detail?.students} />
    </>
  );
};

export default AssessmentInfo;
